import React, { useState, useLayoutEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import 'dayjs/locale/zh-tw';
import PrivateRoute from "@common/components/route/PrivateRoute";
import { Icons, IconButton } from "@curves/ui-base";
import ShowLoading from "./scripts/components/loading/ShowLoading";
import EmployeeLoginDialog from '@icoach/login/EmployeeLoginDialog';
import EmployeePasswordResetDialog from '@icoach/login/EmployeePasswordResetDialog';
import MessageDialog from '@icoach/components/dialog/MessageDialog';
import LoginPage, { ClubResetAuthPage } from '@root/scripts/login';
import Home from '@root/scripts/home';
import AppVersion from '@root/AppVersion';
import { isEmpty } from '@util/utils';
import { EMPLOYEE_LOGIN_ROUTER } from '@icoach/router/routerPath';

// 全局樣式（所有模組共用）
import '@scss/site.scss';
import '@scss/icoach/index.scss';


const ENTRANCE_MAP = {
    CLUBLOGIN: 100,
    EMPLOYEELOGIN: 200,
    EMPLOYEELOGINRESETPASSWORD: 300,
};

const getRoutes = (entrance) => {
    switch (entrance) {
        case ENTRANCE_MAP.CLUBLOGIN:
            return <Route exact strict path={EMPLOYEE_LOGIN_ROUTER.BASE} component={LoginPage} />;
        case ENTRANCE_MAP.EMPLOYEELOGIN:
            return <Route exact strict path={EMPLOYEE_LOGIN_ROUTER.COACH_LOGIN} component={EmployeeLoginDialog} />;
        case ENTRANCE_MAP.EMPLOYEELOGINRESETPASSWORD:
            return <Route exact strict path={EMPLOYEE_LOGIN_ROUTER.COACH_RESET} component={EmployeePasswordResetDialog} />;
        default:
            return null;
    }
};

const App = () => {
    const [entrance, setEntrance] = useState(null);
    const { pathname: rootPath = '' } = useLocation();
    // notistack v3 的關閉方法改由模組層 closeSnackbar 提供（不再掛在 Provider ref 上）
    const onClickDismiss = (snackbarId) => () => {
        closeSnackbar(snackbarId);
    };

    useLayoutEffect(
        () => {
            // 移除路徑末尾的多餘斜杠
            const sanitizedPath = rootPath.replace(/\/+$/, '');
            const [, rootSegment = '', subPath = '', action = ''] = sanitizedPath.split('/');
            switch (true) {
                case rootSegment === 'login' && isEmpty(subPath):
                    setEntrance(ENTRANCE_MAP.CLUBLOGIN);
                    break;

                case rootSegment === 'login' && subPath === 'coach' && isEmpty(action):
                    setEntrance(ENTRANCE_MAP.EMPLOYEELOGIN);
                    break;

                case rootSegment === 'login' && subPath === 'coach' && action === 'reset-password':
                    setEntrance(ENTRANCE_MAP.EMPLOYEELOGINRESETPASSWORD);
                    break;

                case rootSegment === 'club':
                    setEntrance(0);
                    break;

                default:
                    break;
            }
        },
        // eslint-disable-next-line
        [rootPath]
    );

    return (
        <React.Fragment>
            <SnackbarProvider
                className="snacker-massage"
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                action={(snackbarId) => (
                    <IconButton onClick={onClickDismiss(snackbarId)}>
                        <Icons.Close htmlColor="#fff" />
                    </IconButton>
                )}
            >
                <AppVersion />
                <Switch>
                    {getRoutes(entrance)}
                    <Route exact strict path={EMPLOYEE_LOGIN_ROUTER.CLUB_RESET} component={ClubResetAuthPage} />
                    <PrivateRoute as={Home} />
                </Switch>
                <MessageDialog />
            </SnackbarProvider>
            <ShowLoading />
        </React.Fragment>
    );
};

export default App;
